var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"jds-py-4 jds-px-4 jds-whitespace-nowrap jds-text-right jds-font-bold",attrs:{"colspan":_vm.colspan}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }